<template>
      <list
            :columns="columns"
            :modalCreate="modalCreate"
            :removeLink="removeLink"
            :cardLink="cardLink"
            :isUpdate="true"
            :isAdd="true"
            :itemLink="itemLink"
            :setLink="setLink"
  :openItem="false"
            :fields="fields"
            :searchDisable="true"
            @change="change"
            @changeFunction="changeFunction"
            v-model="val"
      />
</template>
<script>
export default {
  name: "products",
  props:['id'],
  created(){
    this.itemLink = `guardians/${this.id}/addresses`;
    this.setLink = `guardians/${this.id}/addresses`;
  },
  methods: {
    changeFunction(val) {},
    change(val) {},
  
  },
  data() {
    return {
      val: [],
      modalCreate: "course_group",
      fields: [

          {
              key: "title",
              label: 'Название адреса',
              placeholder:'Например: домашний адрес',
              type: "field",
              textType: "text",
              col:'col-12',
          },
   
          {
              col:'col-12',
              label: "Город / район",
              key: "cloud_location_id",
              type: "location",
          },
            {
              key: "address",
              label: 'Название улицы',
              placeholder:'Например: ул. Амир Темур 4',
              type: "field",
              textType: "text",
              col:'col-12',
          },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_address",
      itemLink: "address",
      setLink: "address",
      columns: [
          {
            key: "title",
            title: "Название",
            checkbox: false,
            disableLink: true,
            object: 'title',
          },
          {
              key: "full_address",
              title: "Полный адрес",
              checkbox: false,
              control: false,
              align: "left",
              timer: false,
              detail: false,
          },
          {
              // detail: true,
              remove: true,
          },
      ],
    };
  },
};
</script>
<style>
</style>
